var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1Start(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4241 165.23V165.73H35.9241H78.0126H78.5126V165.23V31.2615V30.7615H78.0126H51.7073H51.6139L51.5268 30.7952L1.54675 50.1484L1.08116 50.3287L1.26077 50.7945L13.286 81.985L13.4626 82.443L13.9237 82.2749L35.4241 74.4401V165.23Z",
    stroke: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.144 83.0318L49.6783 55.6201",
    stroke: "url(#paint0_linear_3552_31797)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3552_31797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9241 165.23V73.7257L13.7526 81.8052L1.72729 50.6146L51.7073 31.2615H78.0126V165.23H35.9241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4241 165.23V165.73H35.9241H78.0126H78.5126V165.23V31.2615V30.7615H78.0126H51.7073H51.6139L51.5268 30.7952L1.54675 50.1484L1.08116 50.3287L1.26077 50.7945L13.286 81.985L13.4626 82.443L13.9237 82.2749L35.4241 74.4401V165.23Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3552_31797",
    x: -4.93336,
    y: 24.8931,
    width: 89.3145,
    height: 146.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3552_31797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3552_31797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3552_31797",
    x1: 14.3635,
    y1: 83.0318,
    x2: 49.6783,
    y2: 55.6201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Start);
export default __webpack_public_path__ + "static/media/1__start.376acacc8c103977a64ddab5f0808595.svg";
export { ForwardRef as ReactComponent };